module.exports = __webpack_public_path__ + "img/HPBLACK.d23b465d.png";